import {gCodeParametersStore} from "../stores/GCodeParametersStore";

export enum CncToolType {
    ENGRAVING,      // гравер
    DRILLING,       // сверло
    MILLING,        // фреза
}

export type CncTool = {
    code: string
    type: CncToolType
    diameter: number
    name?: string
}

export function formatToolName(tool: CncTool): string {
    let toolTypeName = ""
    switch (tool.type) {
        case CncToolType.DRILLING :
            toolTypeName = "DRILLING";
            break;
        case CncToolType.ENGRAVING:
            toolTypeName = "ENGRAVING";
            break;
        case CncToolType.MILLING:
            toolTypeName = "MILLING";
            break;

    }
    return tool.name ? tool.name : (toolTypeName + " " + tool.diameter)
}

class ToolService {
    availableTools(): Array<CncTool> {
        let parameters = gCodeParametersStore.getParameters();
        const result: Array<CncTool> = []

        this.addToResult(parameters.toolSet.engravings, CncToolType.ENGRAVING, result)
        this.addToResult(parameters.toolSet.cutters, CncToolType.MILLING, result)
        this.addToResult(parameters.toolSet.drills, CncToolType.DRILLING, result)
        return result
    }

    addTool() {
        let parameters = gCodeParametersStore.getParameters();
        let newDiameter = 0
        if (parameters.toolSet.drills == null || parameters.toolSet.drills.length == 0) {
            parameters.toolSet.drills = []
            newDiameter = 0.2
        } else {
            newDiameter = parameters.toolSet.drills[parameters.toolSet.drills.length - 1] + 0.1
        }
        parameters.toolSet.drills.push(newDiameter)
        gCodeParametersStore.setParameters(parameters)
    }

    removeTool() {
        let parameters = gCodeParametersStore.getParameters();
        let removed = false
        if (parameters.toolSet.drills != null && parameters.toolSet.drills.length > 0 && !removed) {
            parameters.toolSet.drills.splice(parameters.toolSet.drills.length - 2, 1)
            removed = true
        }
        if (parameters.toolSet.engravings != null && parameters.toolSet.engravings.length > 0 && !removed) {
            parameters.toolSet.engravings.splice(parameters.toolSet.engravings.length - 2, 1)
            removed = true
        }
        if (parameters.toolSet.cutters != null && parameters.toolSet.cutters.length > 0 && !removed) {
            parameters.toolSet.cutters.splice(parameters.toolSet.cutters.length - 2, 1)
            removed = true
        }
        gCodeParametersStore.setParameters(parameters)
    }

    private addToResult(tools: Array<number>, type: CncToolType, result: Array<CncTool>) {
        if (tools != undefined && tools.length > 0) {
            tools.forEach(diameter => result.push(this.tool(type, diameter)))
        }
    }

    private toolCode(toolPrefix: string, diameter: number): string {
        return (toolPrefix + "_" + diameter).replace(".", "_").replace(",", "_")
    }

    private tool(toolType: CncToolType, diameter: number): CncTool {
        return {
            code: this.toolCode("mt", diameter),
            type: toolType,
            diameter: diameter
        }
    }
}

const toolService = new ToolService()
export default toolService